import React, {useState, useContext} from 'react';
import moment from "moment";
import __ from "lodash";
import {
  FormControl,
  FormGroup,
  Grid,
  TextField,
  Typography,
  useTheme
} from "@material-ui/core";

import { getSeason } from "../../../functions/GetSeason";
import {
  ComboSelect,
  DatePicker, FlightNumber,
  FormDialog, FormSelect,
  LabelledPaper, MaskedTime, MaskedText, Text,
} from '../../../controls';
import SystemContext from "../../../SystemContext";
import AirportLookup from "../../Airports/components/AirportsLookup";
import ScrMessageView from "./ScrMessageView";
import RequiredDays from "./RequiredDays";
import AddSlotValidator from "../validators/AddSlotValidator";
import {useAddSlot, useUpdateSlot} from "../../../services/slots";
import AircraftLookup from "../../Aircraft/components/AircraftLookup";
import AirportNameTooltip from "../../Airports/components/AirportNameTooltip";
import AirportSlotRequirementList from "../../Airports/components/AirportSlotRequirementList";
import FlightDistinctLookup from "../../Flights/components/FlightDistinctLookup";
import useNextOutboundFlight from "../../../services/flights/useNextOutboundFlight";
import { useQueryClient } from 'react-query';

const dateFormat = "DD/MM/YYYY";
const pickerDateFormat = "YYYY-MM-DD";
const slotTypes = [
  {"code":"TURNROUND","value":"Turnround"},
  {"code":"NON-TURNROUND","value":"Non-Turnround"},
];
const direction = [
//  {"code":"ARRIVAL","value":"Arrival"},
//  {"code":"DEPARTURE","value":"Departure"},
  {"code":"BOTH","value":"Both"},
];

const paperProps = {
  style: {
    backgroundColor: "#f8f8f8",
    boxShadow: 'none',
  }
}

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}

const getSlotLevel = (slotLevelInfo, from) => {
  if (slotLevelInfo && Array.isArray(slotLevelInfo) && from) {
    for (let i = 0; i < slotLevelInfo.length; i++) {
      const season = slotLevelInfo[i];
      if (moment.utc(from).isBetween(moment.utc(season.seasonsStarts), moment.utc(season.seasonsEnds)))
        return (__.has(season, "slotLevel") && !__.isEmpty(season.slotLevel) && season.slotLevel.includes("(2)") ? "SMA" : "SCR");
    }
  }
  return "SCR";
}

const NextDepartingFlight = (props) => {
  const queryClient = useQueryClient();
  const extraKeys = props.inboundTripLegUuid?[props.inboundTripLegUuid]:[props.destinationAirportCode, props.arrivalAirlineCode, props.arrivalFlightNo, props.slotPeriodFrom];
  const flight = useNextOutboundFlight({queryClient, useCache: false, extraKeys});

  let value = "Unknown";

  if (props.renderOnly) {
    value = props.value;
  } else if (flight && flight.data && !flight.data.error) {
    value = `${flight?.data?.airlineCode}-${flight?.data?.flightNo}`;
    if (props.onChange) {
      props.onChange(flight.data);
    }
  }

  return (
    <div>
      <label htmlFor="primaryRoute" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
        {props.label}
      </label>

      <Text
        style={{width: "100%", padding: 0, margin: 0, display: "inline-block"}}
        value={value}
      />
    </div>
)
}

const GenerateSlotDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const theme = useTheme();
  const classes = props.classes;
  const seasons = props.seasons;
  const [dialogStates, setDialogStates] = useState(props.dialogStates);
  const [originalSlotRecord] = useState(props.record?.parentRecord||props.record);
  const [slotRecord, setSlotRecord] = useState({
    ...props.record, 
  });
  const [editing, setEditing] = useState(false);
  const [newSlot, setNewSlot] = useState(props.newSlot || false);

  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  // if ((props.record && !slotRecord) || (!props.record && slotRecord) || (props.record && slotRecord && props.record.awbNo !== slotRecord.awbNo) ) {
  //   setSlotRecord(props.record);
  //   setEditing(true);
  // }

  const SystemData = useContext(SystemContext);

  const handleAddSlot = useAddSlot();
  const handleUpdateSlot = useUpdateSlot();

  const extraKeys = [];

  const createNewRecord = (currentSlot, newSlot) => {
/*
    "N" = "NEW"
    "B" = "NEW ENTRANT"
    "C" = "CHANGE"
    "D" = "CANCEL"
    "P" = "PENDING"
    "A" = "ACCEPT"
    "Z" = "DECLINE"
    "R" = "REVISION"
    "L" = "LIMITED":
*/
    const currentAction = currentSlot.slotActionCode;
    const newAction = newSlot.slotActionCode;
    const currentFrom = currentSlot.slotPeriodFrom;
    const currentTo = currentSlot.slotPeriodTo;
    const newFrom = newSlot.slotPeriodFrom;
    const newTo = newSlot.slotPeriodTo;

    if (currentAction !== newAction) {
      if (["N", "B", "M"].includes(newAction))
        return true;
      if (["C","D"].includes(newAction))
        return true;
    }
    return false;
  }

  const sendConditions = () => {
    if (newSlot)
      return true;
    if (editing)
      return true;
    // if (editing && slotRecord.status === "RECEIVED")
    //   return true;
    // if (editing && slotRecord.status === "CONDITIONAL")
    //   return true;
    // if (editing && slotRecord.status === "OFFER")
    //   return true;
    // if (editing && slotRecord.status === "REJE")
    //   return true;
  }

  const getButtons = () => {
    if (props.canEdit) {
      if (newSlot || sendConditions()) {
        return (
          {
            send:{icon: "send", key: "Send", label: "Save & Send", color: "primary", disabled: (status)=>{return status.error}},
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }
        );
      }
      if (editing) {
        return (
          {
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"},
          }
        );
      }
      return (
        {
          edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }
      )
    }
    return (
      {
        cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
      }
    );
  }

  const requestSubject = (airport, level, season) => {
    const slotLevel = !__.isEmpty(level) && level.includes("(2)") ? "SMA" : "SCR";
    const seasonCode = season && !__.isEmpty(season) ? season.seasonCode: "";

    return `${slotLevel} // ${airport} // ${seasonCode}`;
  }

  const setSlotPeriodTo = (from, to) => {
    const fromDate = moment(from);
    const toDate = moment(to);

    if (!toDate.isValid())
      return from;
    if (toDate.isAfter(fromDate))
      return to;
    return from;
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>
      {slotRecord
        ?
          <FormDialog
            key="generate slot"
            title={`${newSlot?"Generate New Slot Request" :"Update Slot"}${slotRecord?.airportCode?" at " + slotRecord.airportCode:""} for ${slotRecord?.season?.seasonName}`}
            message=""
            open={dialogStates.showDialog}
            dialogOptions={{maxWidth: "md", fullWidth: true, PaperProps: paperProps }}
            record={{
              ...slotRecord,
              ...(props.record.slotActionCode === 'D'
                ?__.pick(originalSlotRecord||slotRecord, [
                  'slotReference',
                  'slotPeriodFrom',
                  'slotPeriodTo',
                  'arrivalAirlineCode',
                  'arrivalFlightNo',
                  'departureAirlineCode',
                  'departureFlightNo',
                  'offsetDays',
                  'departureTime',
                  'destinationAirportCode'
                ])
                :{}
              ),
              slotDirection: 'BOTH'
            }}
            validator={(newSlot || editing)?AddSlotValidator:undefined}
            validatorPosition="top"
            alert={alert}
            formHeightOffset={320}
            titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main}}
            //buttonBarStyleOverride={{position: "relative", width: "calc(100% - 15px)", backgroundColor: "#ffffff", borderTop: `1px solid ${props.fullPageStyle?"grey":"lightgrey"}`, ...props.fullPageStyle}}
            //formBodyStyle={{...props.fullPageStyle}}
            //style={{...props.fullPageStyle}}
            buttons={getButtons()}
            movable
            onChange={(state) => {
              if (state.buttonPressed === "edit" && props.canEdit) {
                setEditing(true);
              }
              if (state.buttonPressed === "cancel") {
                setEditing(false);
                setSlotRecord(props.record);
                setDialogStates({showDialog: false});
                if (props.close)
                  props.close();
              }
              if (state.buttonPressed === "save" || state.buttonPressed === "send") {
                SystemData.toggleLoadingProgress(true);

                if (newSlot || createNewRecord(originalSlotRecord, state.record)) {
                  const newRecord = __.clone(state.record);
                  if (["C","M"].includes(newRecord.slotActionCode)) {
                    newRecord["slotPeriodFrom"] = newRecord.slotChangePeriodFrom;
                    newRecord["slotPeriodTo"] = newRecord.slotChangePeriodTo;
                    newRecord["days"] = newRecord.changeDays;
                  }
                  newRecord["slotUuid"] = undefined;
                  if (!newSlot) {
                    newRecord["status"] = "REQUIRED";
                    newRecord["requestedTime"] = null;
                    newRecord["parentSlotUuid"] = null; //newRecord.parentRecord.slotUuid;
                    newRecord["messageExchange"] = null;
                    //newRecord["parentRecord"] = null;
                  }

                  handleAddSlot.mutate({
                    extraKeys,
                    record: newRecord,
                    postSuccess: (result) => {
                      if (state.buttonPressed === "send" && result.status === "SUCCESS") {
                        const slotRecord = result.record.data;
                        setDialogStates({showDialog: false});
                        if (props.send)
                          props.send(state.record, slotRecord, originalSlotRecord);
                      } else {
                        setEditing(false);
                        setNewSlot(false);
                        setAlert({ severity: "info", open: true, message: `New Slot Request saved`, timeOut: 5 });
                        setDialogStates({showDialog: false});
                        if (props.close)
                          props.close();
                      }
                      SystemData.toggleLoadingProgress(false);
                    },
                    postError: (data) => {
                      SystemData.toggleLoadingProgress(false);
                      if (data.errorMessage) {
                        SystemData.alert("Error", `${data.errorMessage}`);
                      } else {
                        SystemData.alert("Error", `An Unexpected Error has occurred saving the Slot Request`);
                      }
                    }
                  });
                } else {
                  let sendOnly = true;
                  const updatedRecord = state.record;
                  updatedRecord["updatedAt"] = moment().format("YYYY-MM-DD");
                  handleUpdateSlot.mutate({
                    extraKeys,
                    record: updatedRecord,
                    postSuccess: (result) => {
                      if (state.buttonPressed === "send" && result.status === "SUCCESS") {
                        const slotRecord = result.record.data;
                        setDialogStates({showDialog: false});
                        if (props.send)
                          props.send(state.record, state.record, originalSlotRecord);
                      } else {
                        setEditing(false);
                        setNewSlot(false);
                        setAlert({ severity: "info", open: true, message: `Slot Request updated`, timeOut: 5 });
                        setDialogStates({showDialog: false});
                        if (props.close)
                          props.close();
                      }
                      sendOnly = false;
                      SystemData.toggleLoadingProgress(false);
                    },
                    postError: (data) => {
                      sendOnly = false;
                      SystemData.toggleLoadingProgress(false);
                      if (data.errorMessage) {
                        SystemData.alert("Error", `${data.errorMessage}`);
                      } else {
                        SystemData.alert("Error", `An Unexpected Error has occurred updating the Slot Request`);
                      }
                    },
                    postSettled: (result) =>{
                      // There is no change to the record only need to send
                      if (result.error === null && state.buttonPressed === "send" && sendOnly) {
                        const updatedRecord = state.record;
                        updatedRecord["updatedAt"] = moment().format("YYYY-MM-DD");
                        setDialogStates({showDialog: false});
                        if (props.send)
                          props.send(updatedRecord, updatedRecord, originalSlotRecord);
                      } else {
                        setEditing(false);
                        setNewSlot(false);
                        setDialogStates({showDialog: false});
                        if (props.close)
                          props.close();
                      }
                    }
                  });

                  SystemData.toggleLoadingProgress(false);
                }
              } else {
                console.log("Unhandled FormDialog onChange");
              }
            }}
          >
            <Grid container checkChildren={true} spacing={3}>
              <Grid item xs={12} checkChildren={true} row>
                <LabelledPaper {...defaultLabelledPaperProps} label="Slot Details" >
                  <FormControl checkChildren={true} key="FC-slotdetails" style={{display: "block" }}>
                    <FormGroup checkChildren={true} key="FG-slotdetails" style={{padding: "8px 8px 8px 8px"}}>
                      <Grid container checkChildren={true} spacing={3}>

                        <Grid item xs={3} checkchildren="true">
                          {record =>
                            <div>
                              <AirportLookup
                                id="airportCode"
                                label="Slot at Airport"
                                inputLabelProps={{ shrink: true }}
                                style={{width: "100%"}}
                                returnType={"object"}
                                fromDate={record.slotPeriodFrom}
                                toDate={record.slotPeriodTo}
                                readOnly={!newSlot}
                                onChange={(returnObject, props) => {
                                  if (returnObject && returnObject.found) {
                                    const data = {
                                      ...props.record,
                                      airportCode: returnObject.value.toUpperCase(),
                                      airportName: returnObject.data.airportName,
                                      slotBookingEmail: returnObject.data.slotBookingEmail,
                                      slotSubject: requestSubject(returnObject.value.toUpperCase(), returnObject.data.slotLevel, props.record.season),
                                    }
                                    setDialogStates({...dialogStates, airport: returnObject.value.toUpperCase()})
                                    props.recordChange(data);
                                  } else {
                                    props.onChange(returnObject.value);
                                  }
                                }}
                              />

                              {record.airportCode
                                ?
                                  <AirportNameTooltip
                                    airportCode={record.airportCode}
                                    onChange={(airport, props)=> {
                                      if (!__.isEmpty(airport) && airport.airportName !== props.record.airportName) {
                                        const data = {
                                          ...props.record,
                                          airportName: airport.airportName,
                                          slotBookingEmail: airport.slotBookingEmail,
                                          slotSubject: requestSubject(airport.airportCode, airport.slotLevel, props.record.season)
                                        }
                                        setDialogStates({...dialogStates, airport: airport.airportCode})
                                        props.recordChange(data);
                                      }
                                    }}
                                  />
                                :
                                  <></>
                              }
                            </div>
                          }
                        </Grid>
                        <Grid item xs={6} checkChildren={true}>
                          {record => (
                            <AirportSlotRequirementList
                              id="airportCode"
                              airportCode={record.airportCode}
                              displayMode="STRING"
                              airportName={record.airportName}
                              onChange={(slotInfo, props)=> {
                                  if (!__.isEmpty(slotInfo) && props.record.airportCode && record.slotRequired !== slotInfo.slotRequired) {
                                    const data = {
                                      ...props.record,
                                      slotRequired: slotInfo.slotRequired,
                                      slotRequirements: slotInfo.slotRequirements,
                                      slotLevel: getSlotLevel(slotInfo.slotRequirements, record.slotPeriodFrom),
                                    }
                                    props.recordChange(data);
                                  }
                                }
                              }
                            />
                          )}
                        </Grid>
                        <Grid item xs={3} checkchildren="true">
                          {record => (
                            <AircraftLookup
                              id="aircraftTailNumber"
                              label="Aircraft"
                              inputLabelProps={{ shrink: true }}
                              style={{marginTop: "3px"}}
                              readOnly={!newSlot && editing!==true || !record.slotRequired}
                            />
                          )}
                        </Grid>

                        <Grid item xs={3} checkchildren="true">
                          {record => (
                            <FormSelect
                              id="slotType"
                              label="Slot Type"
                              options={slotTypes ? slotTypes : null}
                              readOnly={!newSlot && editing!==true || !record.slotRequired}
                              style={{marginTop: "2px"}}
                              fullWidth
                            />
                          )}
                        </Grid>
                        <Grid item xs={newSlot?6:3} checkchildren="true">
                          {record => (
                            <FormControl checkChildren={true} style={{display: "block"}}>
                              <ComboSelect
                                id="slotActionCode"
                                label="Slot Request"
                                group="SLOTS"
                                subGroup={(newSlot || record.newSlotMode) ? "NEW ACTIONS" : record.status === "OFFER" ? "OFFER ACTIONS" : "UPDATE ACTIONS"}
                                readOnly={!newSlot && editing !== true || !record.slotRequired}
                                //style={{marginTop: "3px"}}
                                fullWidth
                                onChange={(value, props) => {
                                  const data = {
                                    ...props.record,
                                    ...(value === 'D'
                                      ?__.pick(originalSlotRecord||slotRecord, [
                                        'slotReference',
                                        'slotPeriodFrom',
                                        'slotPeriodTo',
                                        'arrivalAirlineCode',
                                        'arrivalFlightNo',
                                        'departureAirlineCode',
                                        'departureFlightNo',
                                        'offsetDays',
                                        'departureTime',
                                        'destinationAirportCode'
                                      ])
                                      :{}
                                    ),
                                    slotDirection: 'BOTH',
                                    slotActionCode: value,
                                    slotChangePeriodFrom: props.record.slotPeriodFrom,
                                    slotChangePeriodTo: props.record.slotPeriodTo,
                                    changeDays: props.record.days
                                  }
                                  props.recordChange(data);
                                }}
                              />
                            </FormControl>)
                          }
                        </Grid>
                        {newSlot
                          ?
                            <></>
                          :
                            <Grid item xs={3} checkchildren="true">
                              {record => (
                                <FormSelect
                                  id="slotDirection"
                                  label="Direction"
                                  options={direction ? direction : null}
                                  readOnly={true || newSlot || editing!==true || !record.slotRequired}
                                  style={{marginTop: "3px"}}
                                  fullWidth
                                />
                              )}
                            </Grid>
                        }
                        <Grid item xs={3} checkChildren={true}>
                          {record => (
                            <MaskedText
                              id="slotReference"
                              label="Reference"
                              inputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              mask={"a".repeat(80)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={{ a: "[a-zA-Z0-9 ]" }}
                              forceUpperCase={true}
                              readOnly={!newSlot && editing!==true || !record.slotRequired}
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} />

                        <Grid item xs={3} checkchildren="true">
                          {record =>
                            <DatePicker
                              id="slotPeriodFrom"
                              label={["C","M"].includes(record.slotActionCode) ? "Reference From" : "Slot Period From"}
                              initialValue= {record.slotPeriodFrom || moment.utc().add(1, "day").format(pickerDateFormat)}
                              minDate={record.slotPeriodFrom || moment.utc().add(1, "day").format(pickerDateFormat)}
                              disableToolbar={true}
                              autoOk={true}
                              format={dateFormat}
                              readOnly={(!newSlot && editing !== true) || !record.slotRequired}
                              onChange={(value, props) => {
                                const data = {
                                  ...props.record,
                                  slotPeriodFrom: value,
                                  slotPeriodTo: setSlotPeriodTo(value, props.record.slotPeriodTo),
                                  season: getSeason(seasons, value),
                                  slotLevel: getSlotLevel(record.slotRequirements, value),
                                }
                                props.recordChange(data);
                              }}
                            />
                          }
                        </Grid>
                        <Grid item xs={3} checkchildren="true">
                          {record =>
                            <DatePicker
                              id="slotPeriodTo"
                              label={["C","M"].includes(record.slotActionCode) ? "Reference To" : "Slot Period To"}
                              //initialValue={dialogStates.fixedDates ? editRow.maxRequiredDate : moment(record.period, "YYYYMM").endOf("month")}
                              minDate={record.slotPeriodFrom}
                              maxDate={moment(record.season?.seasonsEnds).add(1,"day").format(pickerDateFormat)}
                              disableToolbar={true}
                              autoOk={true}
                              format={dateFormat}
                              readOnly={!newSlot && editing !== true || !record.slotRequired}
                            />
                          }
                        </Grid>
                        <Grid item xs={3} checkchildren="true">
                          {record=>
                            record.slotType === "TURNROUND"
                              ?
                              <RequiredDays
                                id="days"
                                label={["C","M"].includes(record.slotActionCode) ? "Reference Days" : "Required Days"}
                                days={record.days}
                                onChange={(updatedDays, props) => {
                                  if (newSlot || editing===true) {
                                    const data = {
                                      ...props.record,
                                      days: updatedDays,
                                    }
                                    props.recordChange(data);
                                  }
                                }}
                              />
                              :
                              <></>
                          }
                        </Grid>

                        {record => ["C", "M"].includes(record.slotActionCode)
                          ?
                            <Grid item xs={12}/>
                          :
                            <></>
                        }

                        {record => ["C","M"].includes(record.slotActionCode)
                          ?
                            <Grid item xs={3} checkchildren="true">
                              <DatePicker
                                id="slotChangePeriodFrom"
                                label="Change From"
                                initialValue= {record.slotPeriodFrom || moment.utc().add(1, "day").format(pickerDateFormat)}
                                minDate={moment.max(moment.utc().add(0, "day").format(pickerDateFormat), moment.utc(record.slotPeriodFrom))}
                                disableToolbar={true}
                                autoOk={true}
                                format={dateFormat}
                                readOnly={!newSlot && editing !== true || !record.slotRequired}
                                onChange={(value, props) => {
                                  const data = {
                                    ...props.record,
                                    slotChangePeriodFrom: value,
                                    slotChangePeriodTo: setSlotPeriodTo(value, props.record.slotChangePeriodFrom)
                                  }
                                  props.recordChange(data);
                                }}
                              />
                            </Grid>
                          :
                            <></>
                        }

                        {record => ["C", "M"].includes(record.slotActionCode)
                          ?
                            <Grid item xs={3} checkchildren="true">
                              <DatePicker
                                id="slotChangePeriodTo"
                                label="Change To"
                                minDate={record.slotChangePeriodFrom}
                                maxDate={moment(record.season?.seasonsEnds).format(pickerDateFormat)}
                                disableToolbar={true}
                                autoOk={true}
                                format={dateFormat}
                                readOnly={!newSlot && editing !== true || !record.slotRequired}
                              />
                            </Grid>
                          :
                            <></>
                        }
                        {record => ["C", "M"].includes(record.slotActionCode)
                          ?
                            <Grid item xs={3} checkchildren="true">
                              {record =>
                                record.slotType === "TURNROUND"
                                  ?
                                  <RequiredDays
                                    id="changeDays"
                                    label={["C", "M"].includes(record.slotActionCode) ? "Change Days" : "Required Days"}
                                    days={record.changeDays}
                                    onChange={(updatedDays, props) => {
                                      if (newSlot || editing === true) {
                                        const data = {
                                          ...props.record,
                                          changeDays: updatedDays,
                                        }
                                        props.recordChange(data);
                                      }
                                    }}
                                  />
                                  :
                                  <></>
                              }
                            </Grid>
                          :
                            <></>
                        }

                        <Grid item xs={12} />
                        <Grid item xs={2} checkchildren="true">
                          {record=>
                            // <FlightNumber
                            //   id="arrivalAirlineCode"
                            //   label="Inbound Flight"
                            //   mask={"XX-999aa"}
                            //   code={record.arrivalAirlineCode}
                            //   number={record.arrivalFlightNo}
                            //   //inputProps={defaultEditProps}
                            //   readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                            //   onChange={(e, props) => {
                            //     const data = {
                            //       ...props.record,
                            //       arrivalAirlineCode: e.code,
                            //       arrivalFlightNo: e.number
                            //     }
                            //     props.recordChange(data);
                            //   }}
                            // />
                            <FlightDistinctLookup
                              id="arrivalAirlineCode"
                              label="Inbound Flight"
                              shrink
                              airportCode={record.airportCode}
                              direction={"IN"}
                              fromDate={["C","M"].includes(record.slotActionCode) ? moment.utc(record.slotChangePeriodFrom, "YYYY-MM-DD").add(-1, 'day').format("YYYY-MM-DD") : moment.utc(record.slotPeriodFrom, "YYYY-MM-DD").add(-1, 'day').format("YYYY-MM-DD")}
                              toDate={["C","M"].includes(record.slotActionCode) ? moment.utc(record.slotChangePeriodTo, "YYYY-MM-DD").add(1, 'day').format("YYYY-MM-DD") : moment.utc(record.slotPeriodTo, "YYYY-MM-DD").add(1, 'day').format("YYYY-MM-DD")}
                              airlineCode={record.arrivalAirlineCode}
                              flightNo={record.arrivalFlightNo}
                              readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                              returnType="object"
                              onChange={(returnObject, props) => {
                                if ( returnObject && __.has(returnObject, "found") && returnObject.found) {
                                  const dow = moment.utc(returnObject.data.scheduledArrivalTimeUTC).isoWeekday();
                                  const days = ['.','.','.','.','.','.','.'];
                                  days[dow - 1] = `${dow}`;
                                  const data = {
                                    ...props.record,
                                    arrivalAirlineCode: returnObject.data.airlineCode,
                                    arrivalFlightNo: returnObject.data.flightNo,
                                    inboundTripLegUuid: returnObject.data.tripLegUuid,
                                    arrivalTime: moment.utc(returnObject.data.scheduledArrivalTimeUTC).format('HH:mm'),
                                    originAirportCode: returnObject.data.originAirportCode,
                                    days: days.join('')
                                  }
                                  props.recordChange(data);
                                }
                                else {
                                  let inboundTripLegUuid = "";
                                  let arrivalAirlineCode = "";
                                  let arrivalFlightNo = "";
                                  if (returnObject && typeof returnObject.value === "string") {
                                    const value = returnObject.value;
                                    if (value.indexOf('-') > -1) {
                                      arrivalAirlineCode = value.split('-')[0];
                                      arrivalFlightNo = value.split('-')[1];
                                    } else if (isNaN(value.substring(2,3))) {
                                      arrivalAirlineCode = value.substring(0,3);
                                      arrivalFlightNo = value.substring(3);
                                    } else if (isNaN(value.substring(1,2))) {
                                      arrivalAirlineCode = value.substring(0,2);
                                      arrivalFlightNo = value.substring(2);
                                    } else if (isNaN(value.substring(0,1))) {
                                      arrivalAirlineCode = value.substring(0,1);
                                      arrivalFlightNo = value.substring(1);
                                    }
                                  }
                                  const data = {
                                    ...props.record,
                                    arrivalAirlineCode: arrivalAirlineCode.toUpperCase(),
                                    arrivalFlightNo: arrivalFlightNo.toUpperCase(),
                                    inboundTripLegUuid
                                  }
                                  props.recordChange(data);
                                }
                              }}
                            />
                          }
                        </Grid>
                        <Grid item xs={2} checkchildren="true">
                          {record=>
                            <NextDepartingFlight 
                              id="departureAirlineCode"
                              inboundTripLegUuid={record.inboundTripLegUuid} 
                              destinationAirportCode={record.airportCode}
                              arrivalAirlineCode={record.arrivalAirlineCode}
                              arrivalFlightNo={record.arrivalFlightNo}
                              slotPeriodFrom={record.slotPeriodFrom}
                              renderOnly={record.slotActionCode === 'D'}
                              label="Outbound Flight"      
                              value={`${record.departureAirlineCode}-${record.departureFlightNo}`}                        
                              onChange={(outboundFlight, props) => {
                                if (outboundFlight) {
                                  const data = {
                                    ...props.record,
                                    departureAirlineCode: outboundFlight.airlineCode,
                                    departureFlightNo: outboundFlight.flightNo,
                                    offsetDays: outboundFlight.offsetDays||0,
                                    departureTime: moment.utc(outboundFlight.scheduledDepartureTimeUTC).format('HH:mm'),
                                    destinationAirportCode: outboundFlight.destinationAirportCode
                                  }
                                  if (JSON.stringify(data) !== JSON.stringify(props.record)){
                                    props.recordChange(data);
                                  }
                                }
                              }}
                            />
                            // <FlightNumber
                            //   id="departureAirlineCode"
                            //   label="Outbound Flight"
                            //   mask={"XX-999aa"}
                            //   code={record.departureAirlineCode}
                            //   number={record.departureFlightNo}
                            //   readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "ARRIVAL"}
                            //   //inputProps={defaultEditProps}
                            //   onChange={(e, props) => {
                            //     const data = {
                            //       ...props.record,
                            //       departureAirlineCode: e.code,
                            //       departureFlightNo: e.number
                            //     }
                            //     props.recordChange(data);
                            //   }}
                            // />
                            // <FlightDistinctLookup
                            //   id="departureAirlineCode"
                            //   label="Outbound Flight"
                            //   shrink
                            //   airportCode={record.airportCode}
                            //   direction={"OUT"}
                            //   fromDate={["C","M"].includes(record.slotActionCode) ? moment.utc(record.slotChangePeriodFrom, "YYYY-MM-DD").add(-1, 'day').format("YYYY-MM-DD") : moment.utc(record.slotPeriodFrom, "YYYY-MM-DD").add(-1, 'day').format("YYYY-MM-DD")}
                            //   toDate={["C","M"].includes(record.slotActionCode) ? moment.utc(record.slotChangePeriodTo, "YYYY-MM-DD").add(9, 'day').format("YYYY-MM-DD") : moment.utc(record.slotPeriodTo, "YYYY-MM-DD").add(1, 'day').format("YYYY-MM-DD")}
                            //   airlineCode={record.departureAirlineCode}
                            //   flightNo={record.departureFlightNo}
                            //   readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                            //   returnType="object"
                            //   onChange={(returnObject, props) => {
                            //     if (returnObject && __.has(returnObject, "found") && returnObject.found) {
                            //       const data = {
                            //         ...props.record,
                            //         departureAirlineCode: returnObject.data.airlineCode,
                            //         departureFlightNo: returnObject.data.flightNo,
                            //       }
                            //       props.recordChange(data);
                            //     } else {
                            //       let arrivalAirlineCode = "";
                            //       let arrivalFlightNo = "";
                            //       if (returnObject && typeof returnObject.value === "string") {
                            //         const value = returnObject.value;
                            //         if (value.indexOf('-') > -1) {
                            //           arrivalAirlineCode = value.split('-')[0];
                            //           arrivalFlightNo = value.split('-')[1];
                            //         } else if (isNaN(value.substring(2,3))) {
                            //           arrivalAirlineCode = value.substring(0,3);
                            //           arrivalFlightNo = value.substring(3);
                            //         } else if (isNaN(value.substring(1,2))) {
                            //           arrivalAirlineCode = value.substring(0,2);
                            //           arrivalFlightNo = value.substring(2);
                            //         } else if (isNaN(value.substring(0,1))) {
                            //           arrivalAirlineCode = value.substring(0,1);
                            //           arrivalFlightNo = value.substring(1);
                            //         }
                            //       }
                            //       const data = {
                            //         ...props.record,
                            //         arrivalAirlineCode: arrivalAirlineCode.toUpperCase(),
                            //         arrivalFlightNo: arrivalFlightNo.toUpperCase(),
                            //       }
                            //       props.recordChange(data);
                            //     }
                            //   }}
                            // />
                          }
                        </Grid>

                        <Grid item xs={2} checkchildren="true">
                          {record => (
                            <AirportLookup
                              id="originAirportCode"
                              label="Origin Airport"
                              inputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              returnType={"object"}
                              readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                              onChange={(returnObject, props) => {
                                if (returnObject && returnObject.found) {
                                  const data = {
                                    ...props.record,
                                    originAirportCode: returnObject.value.toUpperCase(),
                                    originAirportName: returnObject.data.airportName
                                  }
                                  props.recordChange(data);
                                } else {
                                  props.onChange(returnObject.value);
                                }
                              }}
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkchildren="true">
                          {record => (
                            <MaskedTime
                              id="arrivalTime"
                              label="Arrival Time"
                              inputLabelProps={{shrink: true}}
                              readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                            />
                          )}
                        </Grid>
                        <Grid item xs={2} checkchildren="true">
                          {record => (
                            <MaskedTime
                              id="departureTime"
                              label="Departure Time"
                              inputLabelProps={{shrink: true}}
                              readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "ARRIVAL"}
                            />
                          )}
                        </Grid>

                        <Grid item xs={2} checkchildren="true">
                          {record => (
                            <AirportLookup
                              id="destinationAirportCode"
                              label="Destination Airport"
                              inputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              returnType={"object"}
                              readOnly={!newSlot && editing!==true  || !record.slotRequired || record.slotDirection === "ARRIVAL"}
                              onChange={(returnObject, props) => {
                                if (returnObject && returnObject.found) {
                                  const data = {
                                    ...props.record,
                                    destinationAirportCode: returnObject.value.toUpperCase(),
                                    destinationAirportName: returnObject.data.airportName
                                  }
                                  props.recordChange(data);
                                } else {
                                  props.onChange(returnObject.value);
                                }
                              }}
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} />

                        <Grid item xs={3} checkchildren="true">
                          {record => (
                            <FormControl checkChildren={true} style={{display: "block"}}>
                              <ComboSelect
                                id="arrivalService"
                                label="Arrival Flight Type"
                                group="SLOTS"
                                subGroup="SERVICE"
                                readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "DEPARTURE"}
                                //style={{marginTop: "3px"}}
                                fullWidth
                              />
                            </FormControl>
                          )}
                        </Grid>
                        <Grid item xs={3} checkchildren="true">
                          {record => (
                            <FormControl checkChildren={true} style={{display: "block"}}>
                              <ComboSelect
                                id="departureService"
                                label="Departure Flight Type"
                                group="SLOTS"
                                subGroup="SERVICE"
                                readOnly={!newSlot && editing!==true || !record.slotRequired || record.slotDirection === "ARRIVAL"}
                                //style={{marginTop: "3px"}}
                                fullWidth
                              />
                            </FormControl>
                          )}
                        </Grid>
                        <Grid item xs={3} checkChildren={true}>
                          {record => (
                            <MaskedText
                              id="supplementInfo"
                              label="Supplementary Info"
                              inputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              mask={"a".repeat(250)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={{ a: "[a-zA-Z0-9 ]" }}
                              forceUpperCase={true}
                              readOnly={!newSlot && editing!==true || !record.slotRequired}
                            />
                          )}
                        </Grid>
                        <Grid item xs={3} checkChildren={true}>
                          {record => (
                            <MaskedText
                              id="generalInfo"
                              label="General Info"
                              inputLabelProps={{ shrink: true }}
                              style={{width: "100%"}}
                              mask={"a".repeat(250)}
                              maskChar={""}
                              alwaysShowMask={false}
                              formatChars={{ a: "[a-zA-Z0-9 ]" }}
                              forceUpperCase={true}
                              readOnly={!newSlot && editing!==true || !record.slotRequired}
                            />
                          )}
                        </Grid>

                      </Grid>
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>

              {record => {
                const level = record.slotLevel ? (record.slotLevel.includes("3") ? "Level 3" : "Level 2") + " airport " : "";
                const address = record.slotBookingEmail ? " -> " + record.slotBookingEmail : "";
                return (
                  <Grid item xs={12} checkChildren={true}>
                    <LabelledPaper {...defaultLabelledPaperProps} label={`${level}Slot Request Message${address}`} >
                      <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                        <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                          <ScrMessageView slot={record} originalSlot={originalSlotRecord} suppressTitle/>
                        </FormGroup>
                      </FormControl>
                    </LabelledPaper>
                  </Grid>
              )}}
            </Grid>
          </FormDialog>
        :
          <></>
      }
    </div>
  );
}

export default GenerateSlotDialog;
